<section class="section-about-hero">
  <div class="section-container-inside">
    <div class="about-hero-content-box">
      <h1 class="product-hero-header grey-800">
        {{ heroData?.header }}
      </h1>
      <p class="landing-hero-content grey-800">
        {{ heroData?.paragraph }}
      </p>
    </div>
    <figure class="about-hero-image">
      <img
        [src]="heroData?.image?.[0]?.fields?.file?.url"
        [alt]="heroData?.image?.[0]?.fields?.title"
      />
    </figure>
  </div>
  <div class="white-background">&nbsp;</div>
</section>
